// extracted by css-extract-rspack-plugin
export default {"wrapper":"_67c7b1d5"};